import React from "react";
import { useLang } from "../contexts/LanguageContext";

export default function SectionHeader({ eyebrow, title, subtitle, image, align = "left" }) {
  const { dir } = useLang();
  return (
    <section className="relative border-b border-slate200 bg-white" data-testid="section-header">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14 lg:py-20 grid lg:grid-cols-12 gap-10 items-center">
        <div className={`lg:col-span-7 ${align === "center" ? "text-center mx-auto" : ""}`}>
          {eyebrow && <div className="label-eyebrow text-ink mb-4">{eyebrow}</div>}
          <h1 className="heading-serif text-4xl sm:text-5xl lg:text-[58px] text-ink leading-[1.05] mb-5">
            {title}
          </h1>
          {subtitle && (
            <p className="text-[16px] text-slate600 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
        {image && (
          <div className="lg:col-span-5 aspect-[4/3] bg-slate100 overflow-hidden border border-slate200">
            <img src={image} alt="" className="w-full h-full object-cover" />
          </div>
        )}
      </div>
    </section>
  );
}
